import { AntTag } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { LogisticRequest } from 'modules/domain/logisticsKR/types'
import { useTranslation } from 'react-i18next'
import { DispatchingStatusesTags } from 'views/components/DispatchingStatusesTags/DispatchingStatusesTags'
import { TermsTag } from 'views/components/TermsTag/TermsTag'
import { BadgesWrapper } from './styled'

interface Props {
  request: LogisticRequest
}

export const TitleBadges = ({ request }: Props) => {
  const { deal_dispatching_status, logistics_status, created, start_date, close_date } = request
  const { t } = useTranslation('logisticsKR')
  const formatDate = useFormatDate()
  return (
    <BadgesWrapper>
      <DispatchingStatusesTags status={deal_dispatching_status} />
      <AntTag color="white">{t(`statuses.${logistics_status}`)}</AntTag>
      <AntTag color="white">{t('details.created_at', { date_time: formatDate(created, { withTime: true }) })}</AntTag>
      <TermsTag start_date={start_date} close_date={close_date} />
    </BadgesWrapper>
  )
}
